import $ from 'jquery';

// The function actually applying the offset
function offsetAnchor() {
  if (location.hash.length !== 0) {

    if (window.innerWidth < 960) {
      window.scrollTo(window.scrollX, window.scrollY - 100);
    } else {
      window.scrollTo(window.scrollX, window.scrollY - 200);
    }

  }
}

// This will capture on page load
window.addEventListener('load', function() {
  if (location.hash) location.href = location.hash;
  offsetAnchor();
});

// This will capture hash changes while on the page
window.addEventListener('hashchange', function() {
  offsetAnchor();
});

// Let the page finish loading.
(function($) {
  offsetAnchor();

})
